import React, { Component, Fragment } from 'react';
import LogoIcon from 'components/LogoIcon';
import RewardsCardsIcon from 'resources/rewards-cards.png';
import './DisabledFormPage.css';

const DEFAULT_MESSAGE =
  'New account sign up is currently unavailable while we upgrade our systems. We apologize for the inconvenience, please check back later!';

class DisabledFormPage extends Component {
  render() {
    const { formRenderer, shouldDisplaySignUp } = this.props;
    const message =
      (shouldDisplaySignUp && shouldDisplaySignUp.message) || DEFAULT_MESSAGE;

    const body = (
      <Fragment>
        <div className="form-title">
          <LogoIcon />
        </div>
        <h2 className="sr-only focus-start" tabIndex="-1">
          Sign Up currently unavailable
        </h2>
        <div className="form-page disabled-form-page">
          <div className="message">{message}</div>
          <img src={RewardsCardsIcon} alt="" />
        </div>
      </Fragment>
    );

    const overrides = { submitText: '', backClass: 'embedded-hidden' };
    const pageProps = Object.assign({}, this.props, overrides);
    return formRenderer(pageProps, body);
  }
}

DisabledFormPage.FormFields = [];

export default DisabledFormPage;
